import { render, staticRenderFns } from "./Taiwan.vue?vue&type=template&id=aab7a622"
import script from "./Taiwan.vue?vue&type=script&lang=js"
export * from "./Taiwan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../car/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports